import React from 'react'
import Logo from '../ui/Logo'
import { useTranslation } from 'react-i18next'
import { helpLinks, navLinks, PayMethods } from '../../constants/data'
import { Link } from 'react-router-dom'
import MMtech from '../ui/MMtech'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import InnerLoading from '../ui/InnerLoading'

const Footer = () => {
    const { t, i18n } = useTranslation()
    const { siteInfo, loading } = useSelector((state: RootState) => state.settingSlice);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(e.target.value)
        window.location.reload()
    }
    if (loading) return <InnerLoading />
    return (
        <div className=' bg-primary text-white/60'>
            <div className='padding-container  main-prop'>
                <div className='grid lg:grid-cols-8 md:grid-cols-6 xs:grid-cols-1 gap-5'>
                    <div className='xs:col-span-1 sm:col-span-2 md:col-span-3'>
                        <div className=' w-36 mb-3'>
                            <Logo color='white' />
                        </div>
                        <p className=''>{t("footer-text")}</p>
                    </div>
                    <div >
                        <h3 className=' text-white/80 text-xl mb-3  '>{t("links")}</h3>
                        <ul className=' flex flex-col gap-2 text-base'>
                            {navLinks.map((navLink: any, index) => (
                                <li key={index} className=' hover:text-white transition-all'>
                                    <Link to={navLink.path}>{i18n.language === "ar" ? navLink.name_ar : navLink.name_en}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div >
                        <h3 className='text-white/80 text-xl mb-3 '>{t("help")}</h3>
                        <ul className=' flex flex-col gap-2  text-base'>
                            {helpLinks.map((helpLink: any, index) => (
                                <li key={index} className=' hover:text-white transition-all'>
                                    <Link to={helpLink.path}>{i18n.language === "ar" ? helpLink.name_ar : helpLink.name_en}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className='f'>
                        <div className="">
                            <h3 className='text-white/80 text-xl mb-3 '>{t("language")}</h3>
                            <select
                                onChange={handleChange}
                                value={i18n.language}
                                className="w-full bg-primary/10 border border-textSecond px-3 py-2 shadow-sm text-sm focus:outline-none"
                            >
                                <option value="en"> English(UK)</option>
                                <option value="ar">(EG)العربية</option>
                            </select>
                        </div>
                    </div>
                    <div className=' xs:col-span-1 md:col-span-2'>
                        <div className='mb-10'>
                            <h3 className='text-white/80 text-xl mb-3'>{t("payment-method")}</h3>
                            <ul className=' flex  gap-2 '>
                                {PayMethods.map((item: any, index) => (
                                    <li key={index} className=' h-8 w-16 rounded-sm overflow-hidden'>
                                        <img className=' h-full w-full object-cover' src={item.image} alt="" />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h3 className='text-white/80 text-xl mb-3'>{t("communicate-with-us")}</h3>
                            <div className=' flex gap-1'>
                                <p className=' font-semibold text-nowrap'>{t("email")}:</p>
                                <span> {siteInfo?.infoEmail}</span>
                            </div>
                            <div className=' flex gap-1'>
                                <p className=' font-semibold'>{t("phone")}:</p>
                                <span> {siteInfo?.phone}</span>
                            </div>
                            <div className="flex gap-1">
                                <p className="font-semibold">{t("offices.tripoliOffice")}:</p>
                                <span>+218913763007</span>
                            </div>

                            <div className="flex gap-1">
                                <p className="font-semibold">{t("offices.benghaziOffice")}:</p>
                                <span>+218934449040</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div className='padding-container bg-black/20'>
                <MMtech />
            </div>

        </div>
    )
}

export default Footer